export const ENVIRONMENT = import.meta.env.ENVIRONMENT;
export const APP_API_URL = import.meta.env.APP_API_URL;
export const TOKEN_API_URL = import.meta.env.TOKEN_API_URL;
export const BASE_DOMAIN_URL = import.meta.env.BASE_DOMAIN_URL;
